// File: TravelContinentSelector.jsx
// Travel - Select Continent Section (Pure CSS)

import { ChevronRight, MonitorPlay, Notebook, Sailboat, SparkleIcon, ZapOff } from 'lucide-react';
import React, { useState } from 'react';

const continents = [
  { id: 1, name: 'IBPS', icon: <Sailboat size={30} color={`rgba(144, 202, 249,1)`}/> },
  { id: 2, name: 'NABARD', icon: <SparkleIcon size={30} color={`rgba(144, 202, 249,1)`}/> },
  { id: 3, name: 'SEBI', icon: <MonitorPlay size={30} color={`rgba(144, 202, 249,1)`}/> },
  { id: 4, name: 'RBI', icon: <Notebook size={30} color={`rgba(144, 202, 249,1)`}/> },
  { id: 5, name: 'SBI', icon: <ZapOff size={30} color={`rgba(144, 202, 249,1)`}/> },
];

export default function CategoryCard3() {
  const [active, setActive] = useState(2);

  return (<>
    <section className="continent-sec">
      <h2 className="title">Course Categories </h2>

      <div className="continent-grid">
        {continents.map(c => (
          <div
            key={c.id}
            onClick={() => setActive(c.id)}
            className={`continent-card ${active === c.id ? 'active' : ''}`}
          >
            <span className="continent-icon">{c.icon}</span>
            <span className="continent-name">{c.name}</span>
            {/* {active === c.id && (
              <span className="continent-name">{c.name}</span>
            )} */}
          </div>
        ))}
      </div>

      <button className="view-btn"><span className='view-btn-two'>View All Courses <ChevronRight  size={20} /></span></button>
    </section>
    <style>{`
/* File: TravelContinentSelector.css */

.view-btn-two{display: flex;
  gap: 10px;
  justify-content: space-between;}
.continent-sec {
  text-align: center;
  padding: 60px 30px;
  background: #ffffff;
  font-family: Poppins, sans-serif;
}

.title {
  font-size: 32px;
  font-weight: 700;
  color: #000;
  margin-bottom: 35px;
}

.continent-grid {
  display: flex;
  gap: 30px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 35px;
}

.continent-card {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: #f2f3f4;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  transition: .3s;
  border: 2px solid transparent;
}

.continent-card:hover {
  background: #000;
  transform: translateY(-4px);
}

.continent-card.active {
  background: #000;
  transform: scale(1.1);
  border-color: rgba(144, 202, 249,1);
}

.continent-icon {
  font-size: 34px;
  color: #000;
}

.continent-card.active .continent-icon {
  color: rgba(144, 202, 249,1);
}

.continent-name {
  margin-top: 8px;
  font-size: 15px;
  font-weight: 700;
  color: rgba(144, 202, 249,1);
}

.view-btn { 
  background: rgba(144, 202, 249,1);
  border: none;
  padding: 12px 28px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: .3s;
}

.view-btn:hover {
  background: #000;
  color: #fff;
}

@media(max-width:768px){
.continent-sec {
 
  padding: 60px 0px;
 
}
  .continent-card {
    width: 115px;
    height: 115px;
  }
  .continent-icon {
    font-size: 26px;
  }
}`}</style>
    </>
  );
}
